import api from '../Axios';

export const liveStreamAPI = {
  
  // 1. Expert starts a live stream (Now accepts thumbnail file via FormData)
  startStream: async (data: { title: string; thumbnail?: File | null }) => {
    const formData = new FormData();
    formData.append('title', data.title);
    
    if (data.thumbnail) {
      formData.append('thumbnail', data.thumbnail);
    }

    const response = await api.post('/api/live-stream/start', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data; // Returns: { success, streamId, channelName, token, appId }
  },

  // 2. User joins a stream to get an audience token
  joinStream: async (channelName: string) => {
    const response = await api.get('/api/live-stream/join', {
      params: { channelName }
    });
    return response.data; // Returns: { success, token, appId }
  },

  // 3. User reports an active stream
  reportStream: async (data: { streamId: number; reason: string }) => {
    const response = await api.post('/api/live-stream/report', data);
    return response.data;
  },

  // 4. User sends a gift to the expert during a stream
  sendGift: async (data: { 
    streamId: number; 
    expertCode: string; 
    giftType: string; 
    amount: number; 
  }) => {
    const response = await api.post('/api/live-stream/gift', data);
    return response.data;
  },

  // 5. Expert explicitly ends the stream
  endStream: async (data: { channelName: string }) => {
    const response = await api.post('/api/live-stream/end', data);
    return response.data;
  },

  // 6. Fetch all active streams for the lobby
  getActiveStreams: async (category?: string) => {
    const response = await api.get('/api/live-stream/active', {
      params: { category: category !== 'All' ? category : undefined }
    });
    return response.data;
  },
  
};